import React from 'react';
import './product-tabs-content.scss';

export const CONTAINER_CLASS = 'product-tabs__content';
export const CONTAINER_CLASS_ACTIVE = 'product-tabs__content--active';

const ProductTabsContent: React.FC<{ tabKey: string; isActive?: boolean; }> = ({ children, tabKey, isActive }) => (
    <div className={`${CONTAINER_CLASS} ${isActive ? CONTAINER_CLASS_ACTIVE : ''}`} data-key={tabKey}>
        {children}
    </div>
);

export default ProductTabsContent;
